import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SearchTbTipoCambioDto } from '~models/maestros/dto/SearchTbTipoCambioDto';
import { TbTipoCambio } from '~models/maestros/TbTipoCambio';
import { ApiResponse } from '~shared/interface/ApiResponse';

@Injectable({
	providedIn: 'root',
})
export class TbTipoCambioService {
	private readonly _url = `${environment.HOST_MAESTROS_SYNC}/tbtipocambios`;

	constructor(private readonly _http: HttpClient) {}

	findLatestByMonedaAndFchCambio(codMoneda: string, codMonedaConversion: string, fchCambio: Date): Observable<TbTipoCambio> {
		const searchTbTipoCambioDto: SearchTbTipoCambioDto = {
			codMoneda,
			codMonedaConversion,
			fchCambio: fchCambio.toISOString(),
		};

		return this._http.post<ApiResponse<TbTipoCambio>>(`${this._url}/findLatestByMonedaAndFchCambio`, searchTbTipoCambioDto).pipe(map((res) => res.data));
	}
}
